import { render, staticRenderFns } from "./portfolio.vue?vue&type=template&id=d2c2ed2c&scoped=true"
import script from "./portfolio.vue?vue&type=script&lang=js"
export * from "./portfolio.vue?vue&type=script&lang=js"
import style0 from "./portfolio.vue?vue&type=style&index=0&id=d2c2ed2c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2c2ed2c",
  null
  
)

export default component.exports